<div class="nonmatched-user-modal-component" id="nonMatchedUserModal">
	<app-white-verification-modal
		(action)="getAction($event)"
		[title]="title"
		[showCloseIcon]="true"
		[showButtons]="showButtons">
		<ng-container>
			<div class="modal-content">
				<p [translate]="'dashboard.welcome-panel.health-assessment-unavailable'">
					Some myEHE features, including your Health Assessment, are unavailable during this period.
				</p>
				<p [translate]="'dashboard.welcome-panel.contact-if-difficulty'">
					If you are still experiencing difficulty after 24 hours, please contact Member Services at 800.362.8671 or
					<a class="link pb-0" href="mailto:MemberServices@ehe.health">MemberServices&#64;ehe.health.</a>
				</p>
				<p [translate]="'dashboard.welcome-panel.hard-copy-health-assessment'">
					If your exam appointment comes before you have full myEHE access, a hard copy Health Assessment is available
					to bring with you.
					<a
						class="link pb-0 d-inline"
						href="https://ehe.health/wp-content/uploads/2020/12/healthassessmentform.pdf"
						target="_blank"
						><u>Download PDF.</u></a
					>
				</p>
				<p class="font-italic" [translate]="'dashboard.welcome-panel.reference-number'">Reference Number: 3</p>
			</div>
			<div class="d-flex justify-content-center dismiss-btn">
				<button class="button button-medium" mat-button (click)="dismiss()">CONTINUE</button>
			</div>
		</ng-container>
	</app-white-verification-modal>
</div>
<app-ehe-spinner></app-ehe-spinner>
